import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetInboundDocumentKindMutationVariables = Types.Exact<{
  input: Types.SetInboundDocumentKindInput;
}>;


export type SetInboundDocumentKindMutation = { __typename?: 'Mutation', setInboundDocumentKind: { __typename?: 'InboundDocumentPayload', inboundDocument?: { __typename?: 'InboundDocument', id: string, source: Types.InboundDocumentSource, sourceKey: string, fileName: string, fileType: Types.InboundDocumentFileType, sizeBytes: number, pageCount?: number | null, contentHash: string, kind: Types.InboundDocumentKind, kindSource: Types.InboundDocumentKindSource, status: Types.InboundDocumentStatus, rejectReason: string, duplicateOfDocumentId?: string | null, receivedAt: Types.TDateISO, addedAt: Types.TDateISO, addedBy: string, updatedAt: Types.TDateISO, updatedBy: string, routedTo?: { __typename?: 'InboundDocumentRoute', target: Types.InboundDocumentTarget, targetRecordId: string, routedAt: Types.TDateISO, routedBy: string, counterparty?: { __typename?: 'InboundDocumentCounterparty', type: Types.InboundDocumentCounterpartyType, id: string } | null } | null, email?: { __typename?: 'InboundDocumentEmail', sender: string, originalSender: string, recipient: string, messageId: string, attachmentId: string, subject: string, noteText: string, dmarcPass: boolean, isAutomatic: boolean, ack: { __typename?: 'InboundDocumentAck', state: Types.InboundDocumentAckState, reason: string, claimedAt?: Types.TDateISO | null, sentAt?: Types.TDateISO | null, providerMessageId?: string | null } } | null } | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> } };

export type RouteInboundDocumentMutationVariables = Types.Exact<{
  input: Types.RouteInboundDocumentInput;
}>;


export type RouteInboundDocumentMutation = { __typename?: 'Mutation', routeInboundDocument: { __typename?: 'InboundDocumentPayload', inboundDocument?: { __typename?: 'InboundDocument', id: string, source: Types.InboundDocumentSource, sourceKey: string, fileName: string, fileType: Types.InboundDocumentFileType, sizeBytes: number, pageCount?: number | null, contentHash: string, kind: Types.InboundDocumentKind, kindSource: Types.InboundDocumentKindSource, status: Types.InboundDocumentStatus, rejectReason: string, duplicateOfDocumentId?: string | null, receivedAt: Types.TDateISO, addedAt: Types.TDateISO, addedBy: string, updatedAt: Types.TDateISO, updatedBy: string, routedTo?: { __typename?: 'InboundDocumentRoute', target: Types.InboundDocumentTarget, targetRecordId: string, routedAt: Types.TDateISO, routedBy: string, counterparty?: { __typename?: 'InboundDocumentCounterparty', type: Types.InboundDocumentCounterpartyType, id: string } | null } | null, email?: { __typename?: 'InboundDocumentEmail', sender: string, originalSender: string, recipient: string, messageId: string, attachmentId: string, subject: string, noteText: string, dmarcPass: boolean, isAutomatic: boolean, ack: { __typename?: 'InboundDocumentAck', state: Types.InboundDocumentAckState, reason: string, claimedAt?: Types.TDateISO | null, sentAt?: Types.TDateISO | null, providerMessageId?: string | null } } | null } | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> } };

export type DiscardInboundDocumentMutationVariables = Types.Exact<{
  input: Types.DiscardInboundDocumentInput;
}>;


export type DiscardInboundDocumentMutation = { __typename?: 'Mutation', discardInboundDocument: { __typename?: 'InboundDocumentPayload', inboundDocument?: { __typename?: 'InboundDocument', id: string, source: Types.InboundDocumentSource, sourceKey: string, fileName: string, fileType: Types.InboundDocumentFileType, sizeBytes: number, pageCount?: number | null, contentHash: string, kind: Types.InboundDocumentKind, kindSource: Types.InboundDocumentKindSource, status: Types.InboundDocumentStatus, rejectReason: string, duplicateOfDocumentId?: string | null, receivedAt: Types.TDateISO, addedAt: Types.TDateISO, addedBy: string, updatedAt: Types.TDateISO, updatedBy: string, routedTo?: { __typename?: 'InboundDocumentRoute', target: Types.InboundDocumentTarget, targetRecordId: string, routedAt: Types.TDateISO, routedBy: string, counterparty?: { __typename?: 'InboundDocumentCounterparty', type: Types.InboundDocumentCounterpartyType, id: string } | null } | null, email?: { __typename?: 'InboundDocumentEmail', sender: string, originalSender: string, recipient: string, messageId: string, attachmentId: string, subject: string, noteText: string, dmarcPass: boolean, isAutomatic: boolean, ack: { __typename?: 'InboundDocumentAck', state: Types.InboundDocumentAckState, reason: string, claimedAt?: Types.TDateISO | null, sentAt?: Types.TDateISO | null, providerMessageId?: string | null } } | null } | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> } };

export type RotateInboundIntakeAddressMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RotateInboundIntakeAddressMutation = { __typename?: 'Mutation', rotateInboundIntakeAddress: { __typename?: 'InboundIntakeSettingsPayload', settings?: { __typename?: 'InboundIntakeSettings', address: string, previousAddress?: string | null, previousAddressValidUntil?: Types.TDateISO | null, rotatedAt: Types.TDateISO, replyToForwarder: boolean, acceptedFileTypes: Array<string>, maxBytes: number, allowedSenders: Array<{ __typename?: 'InboundAllowedSender', id: string, type: Types.InboundAllowedSenderType, value: string, addedAt: Types.TDateISO, addedBy: string }> } | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> } };

export type AddInboundAllowedSenderMutationVariables = Types.Exact<{
  input: Types.AddInboundAllowedSenderInput;
}>;


export type AddInboundAllowedSenderMutation = { __typename?: 'Mutation', addInboundAllowedSender: { __typename?: 'InboundIntakeSettingsPayload', settings?: { __typename?: 'InboundIntakeSettings', address: string, previousAddress?: string | null, previousAddressValidUntil?: Types.TDateISO | null, rotatedAt: Types.TDateISO, replyToForwarder: boolean, acceptedFileTypes: Array<string>, maxBytes: number, allowedSenders: Array<{ __typename?: 'InboundAllowedSender', id: string, type: Types.InboundAllowedSenderType, value: string, addedAt: Types.TDateISO, addedBy: string }> } | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> } };

export type RemoveInboundAllowedSenderMutationVariables = Types.Exact<{
  input: Types.RemoveInboundAllowedSenderInput;
}>;


export type RemoveInboundAllowedSenderMutation = { __typename?: 'Mutation', removeInboundAllowedSender: { __typename?: 'InboundIntakeSettingsPayload', settings?: { __typename?: 'InboundIntakeSettings', address: string, previousAddress?: string | null, previousAddressValidUntil?: Types.TDateISO | null, rotatedAt: Types.TDateISO, replyToForwarder: boolean, acceptedFileTypes: Array<string>, maxBytes: number, allowedSenders: Array<{ __typename?: 'InboundAllowedSender', id: string, type: Types.InboundAllowedSenderType, value: string, addedAt: Types.TDateISO, addedBy: string }> } | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> } };

export type UpdateInboundDocumentSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateInboundDocumentSettingsInput;
}>;


export type UpdateInboundDocumentSettingsMutation = { __typename?: 'Mutation', updateInboundDocumentSettings: { __typename?: 'InboundIntakeSettingsPayload', settings?: { __typename?: 'InboundIntakeSettings', address: string, previousAddress?: string | null, previousAddressValidUntil?: Types.TDateISO | null, rotatedAt: Types.TDateISO, replyToForwarder: boolean, acceptedFileTypes: Array<string>, maxBytes: number, allowedSenders: Array<{ __typename?: 'InboundAllowedSender', id: string, type: Types.InboundAllowedSenderType, value: string, addedAt: Types.TDateISO, addedBy: string }> } | null, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> } };


export const SetInboundDocumentKindDocument = new TypedDocumentString(`
    mutation SetInboundDocumentKind($input: SetInboundDocumentKindInput!) {
  setInboundDocumentKind(input: $input) {
    inboundDocument {
      ...InboundDocumentFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InboundDocumentFields on InboundDocument {
  id
  source
  sourceKey
  fileName
  fileType
  sizeBytes
  pageCount
  contentHash
  kind
  kindSource
  status
  rejectReason
  duplicateOfDocumentId
  routedTo {
    target
    targetRecordId
    counterparty {
      type
      id
    }
    routedAt
    routedBy
  }
  email {
    sender
    originalSender
    recipient
    messageId
    attachmentId
    subject
    noteText
    dmarcPass
    isAutomatic
    ack {
      state
      reason
      claimedAt
      sentAt
      providerMessageId
    }
  }
  receivedAt
  addedAt
  addedBy
  updatedAt
  updatedBy
}`);
export const RouteInboundDocumentDocument = new TypedDocumentString(`
    mutation RouteInboundDocument($input: RouteInboundDocumentInput!) {
  routeInboundDocument(input: $input) {
    inboundDocument {
      ...InboundDocumentFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InboundDocumentFields on InboundDocument {
  id
  source
  sourceKey
  fileName
  fileType
  sizeBytes
  pageCount
  contentHash
  kind
  kindSource
  status
  rejectReason
  duplicateOfDocumentId
  routedTo {
    target
    targetRecordId
    counterparty {
      type
      id
    }
    routedAt
    routedBy
  }
  email {
    sender
    originalSender
    recipient
    messageId
    attachmentId
    subject
    noteText
    dmarcPass
    isAutomatic
    ack {
      state
      reason
      claimedAt
      sentAt
      providerMessageId
    }
  }
  receivedAt
  addedAt
  addedBy
  updatedAt
  updatedBy
}`);
export const DiscardInboundDocumentDocument = new TypedDocumentString(`
    mutation DiscardInboundDocument($input: DiscardInboundDocumentInput!) {
  discardInboundDocument(input: $input) {
    inboundDocument {
      ...InboundDocumentFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InboundDocumentFields on InboundDocument {
  id
  source
  sourceKey
  fileName
  fileType
  sizeBytes
  pageCount
  contentHash
  kind
  kindSource
  status
  rejectReason
  duplicateOfDocumentId
  routedTo {
    target
    targetRecordId
    counterparty {
      type
      id
    }
    routedAt
    routedBy
  }
  email {
    sender
    originalSender
    recipient
    messageId
    attachmentId
    subject
    noteText
    dmarcPass
    isAutomatic
    ack {
      state
      reason
      claimedAt
      sentAt
      providerMessageId
    }
  }
  receivedAt
  addedAt
  addedBy
  updatedAt
  updatedBy
}`);
export const RotateInboundIntakeAddressDocument = new TypedDocumentString(`
    mutation RotateInboundIntakeAddress {
  rotateInboundIntakeAddress {
    settings {
      ...InboundIntakeSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InboundIntakeSettingsFields on InboundIntakeSettings {
  address
  previousAddress
  previousAddressValidUntil
  rotatedAt
  allowedSenders {
    id
    type
    value
    addedAt
    addedBy
  }
  replyToForwarder
  acceptedFileTypes
  maxBytes
}`);
export const AddInboundAllowedSenderDocument = new TypedDocumentString(`
    mutation AddInboundAllowedSender($input: AddInboundAllowedSenderInput!) {
  addInboundAllowedSender(input: $input) {
    settings {
      ...InboundIntakeSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InboundIntakeSettingsFields on InboundIntakeSettings {
  address
  previousAddress
  previousAddressValidUntil
  rotatedAt
  allowedSenders {
    id
    type
    value
    addedAt
    addedBy
  }
  replyToForwarder
  acceptedFileTypes
  maxBytes
}`);
export const RemoveInboundAllowedSenderDocument = new TypedDocumentString(`
    mutation RemoveInboundAllowedSender($input: RemoveInboundAllowedSenderInput!) {
  removeInboundAllowedSender(input: $input) {
    settings {
      ...InboundIntakeSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InboundIntakeSettingsFields on InboundIntakeSettings {
  address
  previousAddress
  previousAddressValidUntil
  rotatedAt
  allowedSenders {
    id
    type
    value
    addedAt
    addedBy
  }
  replyToForwarder
  acceptedFileTypes
  maxBytes
}`);
export const UpdateInboundDocumentSettingsDocument = new TypedDocumentString(`
    mutation UpdateInboundDocumentSettings($input: UpdateInboundDocumentSettingsInput!) {
  updateInboundDocumentSettings(input: $input) {
    settings {
      ...InboundIntakeSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment InboundIntakeSettingsFields on InboundIntakeSettings {
  address
  previousAddress
  previousAddressValidUntil
  rotatedAt
  allowedSenders {
    id
    type
    value
    addedAt
    addedBy
  }
  replyToForwarder
  acceptedFileTypes
  maxBytes
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetInboundDocumentKind: build.mutation<SetInboundDocumentKindMutation, SetInboundDocumentKindMutationVariables>({
      query: (variables) => ({ document: SetInboundDocumentKindDocument, variables })
    }),
    RouteInboundDocument: build.mutation<RouteInboundDocumentMutation, RouteInboundDocumentMutationVariables>({
      query: (variables) => ({ document: RouteInboundDocumentDocument, variables })
    }),
    DiscardInboundDocument: build.mutation<DiscardInboundDocumentMutation, DiscardInboundDocumentMutationVariables>({
      query: (variables) => ({ document: DiscardInboundDocumentDocument, variables })
    }),
    RotateInboundIntakeAddress: build.mutation<RotateInboundIntakeAddressMutation, RotateInboundIntakeAddressMutationVariables | void>({
      query: (variables) => ({ document: RotateInboundIntakeAddressDocument, variables })
    }),
    AddInboundAllowedSender: build.mutation<AddInboundAllowedSenderMutation, AddInboundAllowedSenderMutationVariables>({
      query: (variables) => ({ document: AddInboundAllowedSenderDocument, variables })
    }),
    RemoveInboundAllowedSender: build.mutation<RemoveInboundAllowedSenderMutation, RemoveInboundAllowedSenderMutationVariables>({
      query: (variables) => ({ document: RemoveInboundAllowedSenderDocument, variables })
    }),
    UpdateInboundDocumentSettings: build.mutation<UpdateInboundDocumentSettingsMutation, UpdateInboundDocumentSettingsMutationVariables>({
      query: (variables) => ({ document: UpdateInboundDocumentSettingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetInboundDocumentKindMutation, useRouteInboundDocumentMutation, useDiscardInboundDocumentMutation, useRotateInboundIntakeAddressMutation, useAddInboundAllowedSenderMutation, useRemoveInboundAllowedSenderMutation, useUpdateInboundDocumentSettingsMutation } = injectedRtkApi;
